import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";

import "./RoutePlanLeft.scss";
import RoutePlanMenu from "../Menu/RoutePlan";

const RoutePlanLeft = ({ routePlan, canEdit = true }) => {
  return (
    <div className="RoutePlanLeft">
      {canEdit && (
        <div className="RoutePlanLeft__Top">
          <Link to={`/route-plans/${routePlan?._id}`}>
            <div className="RoutePlanLeft__Top__Title">{moment(routePlan?.deliveryDate).utc().format("MMM")}</div>
            <div className="RoutePlanLeft__Top__Sub">{moment(routePlan?.deliveryDate).utc().format("DD")}</div>
          </Link>
        </div>
      )}
      <RoutePlanMenu routePlan={routePlan} canEdit={canEdit} />
    </div>
  );
};

export default RoutePlanLeft;
